export const getStreamErrorMessages = {
  userToken: 'There was an error fetching your user token',
  userFeedPosts: 'There was an error fetching your feed posts',
  teamPosts: "There was an error fetching this team's feed posts",
  updateActivityComments: "There was an error fetching this post's comments",
  createPostSuccess: 'Posted',
  createPostError: 'Exceeded character limit',
};
export const NOTIFICATION_POLL_TIME = 60000;
